<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <form ref="insect_add" @submit.prevent="addContract">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>add</md-icon>
                        </div>
                        <h4 class="title">Ajout d'un contrat</h4>
                    </md-card-header>
                    <contract-form :contract="contract" action="add" :errors="errors"></contract-form>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">
                            Enregistrer
                        </md-button>
                        <md-button class="md-warning"
                                   @click="goBack">
                            Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
import ContractForm from "@/pages/Contracts/components/ContractForm";
export default {
    name: "ContractAdd",
    components: {
        ContractForm
    },
    data() {
        return {
            contract: {
                number: null,
                isSettingUp: false,
                settingUpComment: '',
                periodDuration: 12,
                periodRepetition: null,
                isTacit: true,
				daysNotice: null,
				percentIncrease: null,
                billingMonths: [],
                billingInfos: '',
                comment: '',
                clientRelation: '',
                isActive: false,
				period: {
					dateStart: null,
					dateEnd: null,
					amount: null,
				}
            },
            errors: []
        }
    },
    methods: {
        async addContract() {
            this.errors = []
            try {
                const { data } = await this.$store.dispatch('contracts/addContract', {
                    site_id: this.$route.params.idSite,
					number: this.contract.number,
					is_active: this.contract.isActive,
					period_duration: this.contract.periodDuration,
					period_repetition: this.contract.periodRepetition,
					date_start: this.contract.period.dateStart === '' ? null : this.$moment(this.contract.period.dateStart).format('YYYY-MM-DD'),
					date_end: this.contract.period.dateEnd === '' ? null : this.$moment(this.contract.period.dateEnd).format('YYYY-MM-DD'),
					is_setting_up: this.contract.isSettingUp,
					setting_up_comment: this.contract.settingUpComment,
					is_tacit: this.contract.isTacit,
					days_notice: parseInt(this.contract.daysNotice),
					percent_increase: parseFloat(this.contract.percentIncrease),
					billing_months: this.contract.billingMonths.map(month => parseInt(month)),
					billing_info: this.contract.billingInfos,
					comment: this.contract.comment,
					client_relation: this.contract.clientRelation,
					amount: parseFloat(this.contract.period.amount)
                })
                await this.$store.dispatch('alerts/success', 'Contrat ajouté')
                await this.$router.push({ name: 'Contract Details', params: { contractId: data.id }})
            } catch (e) {
                this.errors = e.response.data.errors
            }
        },
        goBack() {
            this.$router.back()
        }
    }
}
</script>

<style scoped>

</style>
